import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CheckItem } from '../CheckItem';
import { withoutSystem, withSystem } from '../../data/salesContent';
export function ComparisonSection() {
  return <section className="bg-zinc-950 px-5 py-20 md:py-28" data-id="element-83" data-mp="515usco5gf9i">
      <div className="mx-auto max-w-5xl" data-id="element-84" data-mp="52qo5yyq9s5s">
        <SectionHeading title="Preparar todo desde cero vs. trabajar con un sistema organizado." data-id="element-85" data-mp="9yefol0omxeg" />
        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-86" data-mp="3rewc603ywjb1">
          <div className="rounded-xl border border-zinc-800 bg-zinc-900/60 p-7 md:p-9" data-id="element-87" data-mp="19qsdfgcnty">
            <h3 className="font-display text-2xl font-extrabold uppercase tracking-wide text-zinc-400 md:text-3xl" data-id="element-88" data-mp="34e1ye74s17">Sin el Mega Pack</h3>
            <ul className="mt-6 space-y-4" data-id="element-89" data-mp="3ndu732nddd15">
              {withoutSystem.map(i => <CheckItem key={i} variant="cross" className="text-lg text-zinc-400" data-id="element-90" data-mp="3nbzqu1n1m93e">
                  {i}
                </CheckItem>)}
            </ul>
          </div>
          <div className="rounded-xl border-2 border-amber-400 bg-zinc-900 p-7 md:p-9" data-id="element-91" data-mp="3dfobt3w2j559">
            <h3 className="font-display text-2xl font-extrabold uppercase tracking-wide text-amber-400 md:text-3xl" data-id="element-92" data-mp="z6friqp151zk">Con el Mega Pack</h3>
            <ul className="mt-6 space-y-4" data-id="element-93" data-mp="ub0gs7mbjm7d">
              {withSystem.map(i => <CheckItem key={i} className="text-lg font-medium text-zinc-50" data-id="element-94" data-mp="187vsk7tyfrr4">
                  {i}
                </CheckItem>)}
            </ul>
          </div>
        </div>
        <div className="mt-14 text-center" data-id="element-95" data-mp="gggbsuf2wz8t">
          <p className="font-display mx-auto max-w-3xl text-3xl font-extrabold uppercase leading-tight text-zinc-50 md:text-5xl" data-id="element-96" data-mp="gf562p22phf2">
            Tu próxima capacitación no tiene que empezar <span className="text-amber-400" data-id="element-97" data-mp="pb4dkalg3ysv">desde cero.</span>
          </p>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-zinc-400 md:text-xl" data-id="element-98" data-mp="kikxn6zacrkw">
            Ahorrá tiempo de preparación y concentrá tus esfuerzos en lo más importante: enseñar.
          </p>
        </div>
      </div>
    </section>;
}